module.exports = __webpack_public_path__ + "static/atlas-overview-866ff8ba676da6edecf8498805a0677e.png";